/** Sets the options of a workflow's current version without publishing a new one. */
class SaveOrganizationWorkflowOptions {
	constructor(
		public readonly organizationId: number,
		public readonly workflowKey: string,
		public readonly separatesSpeakers: boolean,
	) {
		Object.freeze(this);
	}

	toJSON(): { separatesSpeakers: boolean } {
		return { separatesSpeakers: this.separatesSpeakers };
	}
}

export default SaveOrganizationWorkflowOptions;
